var GtxCountersWorkerManager = (function () {

    let fetching = false;
    let pollingInterval = 300000;
    let maxRetries = 0;

    const loggingEnabled = false;
    const log = {
        info: (...data) => {
            if (loggingEnabled) {
                console.info(...data)
            }
        }
    }
    const isSwFeatSupported = "serviceWorker" in navigator && "BroadcastChannel" in window;

    const WORKER_SCOPE = "/bundles/workers/menu-counters-worker.js";

    const LOCAL_STORAGE_KEY = "gtx-counters-data";

    let msgBroadcastChannel = null;

    const events = {
        COUNTERS_UPDATE_REQ: "gtx_menu_counter_manager_update_request",
        UPDATE_COUNTERS: "gtx_menu_counter_manager_counter_update",
        LOADING_COUNTERS: "gtx_menu_counter_manager_counter_loading",
    };

    const writeCounterDataInLocalStorage = (evt) => {
        log.info('writeCounterDataInLocalStorage > evt.detail', evt.detail)

        if (evt.detail && window.localStorage) {
            log.info('writeCounterDataInLocalStorage > JSON.stringify(evt.detail)', JSON.stringify(evt.detail))
            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(evt.detail))
        }
    }

    /**
     * 
     * This func is called every time a counter update is requested:
     * - on service worker received message on broadcast channel `gtx-menu-counters-update`
     * - on success of the first main thread api call
     * - an update counter request event `events.COUNTERS_UPDATE_REQ` is received
     * 
     * It:
     * - Emits custom event `gtx_menu_counter_manager_counter_update` which will be intercepted by other fe components
     * 
     * @param counters 
     */
    const emitCountersUpdate = (counters) => {
        log.info('Emitting gtx_menu_counter_manager_counter_update', counters)
        window.dispatchEvent(new CustomEvent(
            events.UPDATE_COUNTERS,
            {
                detail: {
                    ...counters,
                    newMatches: window.gtxLoggedUser.hasMatches ? counters.newMatches : 0
                }
            }
        ));
    }

    const getCounters = () => {
        fetching = true;

        return (
            window
                .fetch("/api/menu/counters")
                .then((resp) => {
                    fetching = false;
                    pollingInterval = Number(resp.headers.get("Menu-Counters-Polling-Interval")) * 1000;
                    maxRetries = Number(resp.headers.get("Menu-Counters-Polling-Retries")) || 0;

                    return resp.json();
                })
                .then((resp) => {
                    if (resp.status === 'error') {
                        //throwing a simple error to reject the promise.
                        throw Error('gtx-menu-counters-worker-manager.js: Error fetching counters')
                    }
                    return resp.data
                })
                .catch(() => {
                    return {
                        unreadThreads: 0,
                        newMatches: 0,
                        newAgencyActiveSearches: 0
                    }
                })
        );
    };

    const updateCountersWithoutLoading = () => {
        getCounters().then((data) => {
            emitCountersUpdate(data);
        });
    };

    const updateCountersWithLoading = () => {
        window.dispatchEvent(new CustomEvent(
            events.LOADING_COUNTERS,
            { detail: { isLoading: true } }
        ));

        return getCounters()
            .then((data) => {
                emitCountersUpdate(data);
            })
            .finally(() => {
                window.dispatchEvent(new CustomEvent(
                    events.LOADING_COUNTERS,
                    { detail: { isLoading: false } }
                ));
            })
    }

    function initializeServiceWorker() {
        if (isSwFeatSupported) {
            let isServiceWorkerInstalling = false;

            navigator.serviceWorker
                .register(WORKER_SCOPE, {
                    scope: WORKER_SCOPE,
                })
                .then(function (registration) {
                    if (registration.installing) {
                        isServiceWorkerInstalling = true;

                        postMessageToSwPolling({
                            sw: registration.installing,
                            action: {
                                type: "keep-alive",
                                payload: {
                                    interval: pollingInterval,
                                    maxRetries
                                },
                            },
                        });
                    } else if (registration.active) {
                        // ? check if new version of sw is available
                        registration.update();

                        postMessageToSwPolling({
                            sw: registration.active,
                            action: {
                                type: "keep-alive",
                                payload: { interval: pollingInterval, maxRetries },
                            },
                        });
                    }

                    registration.addEventListener("updatefound", (evt) => {
                        /**
                         * This event is fired when the service worker is installing.
                         * And we don't want this.
                         * To avoid multiple calls to this event, we set a flag to true
                         */
                        if (!isServiceWorkerInstalling && registration) {
                            postMessageToSwPolling({
                                sw: registration.installing || registration.waiting || registration.active,
                                action: {
                                    type: "keep-alive",
                                    payload: { interval: pollingInterval, maxRetries },
                                },
                            });
                        }
                        isServiceWorkerInstalling = false;
                    });
                })
                .catch(function (err) {
                    log.info("[/workers/menu-counters-worker.js]", "ServiceWorker registration failed: ", err);
                });
        }
    }

    /**
     *
     * @param {{sw: ServiceWorker, action: {type: "keep-alive" | "stop" | "forced-restart", payload: any  }} config
    * @param {{message: string, color: string}} debug
    * @returns {void}
    */
    const postMessageToSwPolling = ({ sw, action }, debug) => {
        if (debug) {
            console.debug(
                `%c[ServiceWorker] ${debug.message}!`,
                `color: ${debug.color}; font-size: 16px; font-weight: bold;`
            );
        }

        return sw.postMessage({
            type: `menu-counters-worker:polling-${action.type}`,
            payload: action.payload || {},
        });
    };

    const initialize = () => {
        if (isSwFeatSupported) {
            const OLD_WORKER_SCOPE = "/bundles/workers/messaging-worker.js";
            window.navigator.serviceWorker
                .getRegistration(OLD_WORKER_SCOPE)
                .then(registration => {
                    registration.unregister()
                })
                .catch(() => { })
        }
        updateCountersWithLoading()
            .then(() => initializeServiceWorker())

        /**
         * Questa func viene eseguita in risposta ad un evento di richiesta aggiornamento counters
         * events.COUNTERS_UPDATE_REQ
         */
        const countersUpdateReqCallback = () => {
            log.info('countersUpdateReqCallback')
            if (isSwFeatSupported) {
                window.navigator.serviceWorker.getRegistration(WORKER_SCOPE).then((pollingServiceWorker) => {
                    if (pollingServiceWorker && msgBroadcastChannel) {
                        postMessageToSwPolling({
                            sw:
                                pollingServiceWorker.installing ||
                                pollingServiceWorker.active ||
                                pollingServiceWorker.waiting,
                            action: {
                                type: "forced-restart",
                            },
                        });
                    }
                });
            } else {
                updateCountersWithoutLoading();
            }
        };

        window.addEventListener(events.COUNTERS_UPDATE_REQ, countersUpdateReqCallback);

        if ("BroadcastChannel" in window) {
            msgBroadcastChannel = new window.BroadcastChannel("gtx-menu-counters-update");

            msgBroadcastChannel.addEventListener("message", (ev) => {
                emitCountersUpdate(ev.data);
            });
        }

        if (localStorage) {
            window.addEventListener(events.UPDATE_COUNTERS, writeCounterDataInLocalStorage)
        }


    };

    return {
        initialize,
        events
    };

})()

module.exports = GtxCountersWorkerManager;
